import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import {
    tournamentUserGetFollow_req,
    tournamentUserUnfollow_req,
} from '../../../../api/tournament/tournament.api';
import LevelBar from '../../../../components/bars/level-bar/level.bar';
import PopupsEnum from '../../../../enums/popups.enum';
import { openPopups } from '../../../../redux/popup.slice';
import './followed-content.scss';

const FollowedContent = ({ tournament }) => {
    const intl = useIntl();
    const dispatch = useDispatch();
    const [success, setSuccess] = useState(false);
    const [followedUser, setFollowedUser] = useState([]);
    const followedList = async () => {
        const tourId = tournament.id;
        const followedListData = await tournamentUserGetFollow_req(tourId);

        setFollowedUser(followedListData);
    };
    useEffect(() => {
        followedList();
    }, [success]);

    const unFollowingUser = (userId) => {
        const tourId = tournament.id;
        dispatch(
            openPopups({
                popupIds: [PopupsEnum.UNFOLLOW_POPUP],
                popupData: [
                    {
                        userId: userId,
                        tourId: tourId,
                        setSuccess: setSuccess,
                    },
                ],
            })
        );
    };
    // const unFollowingUser = async (userId) => {
    //     const tourId = tournament.tournamentId;
    //     try {
    //         const followingUserData = await tournamentUserUnfollow_req(
    //             tourId,
    //             userId
    //         );
    //     } catch (e) {}
    // };
    if (!followedUser) return null;

    return (
        <div className="dashboard-content">
            {followedUser &&
                followedUser.data &&
                followedUser.data.userFollowings &&
                followedUser.data.userFollowings.map((item, index) => {
                    return (
                        <div className="content-line">
                            <div className="user-leaderboard-img-block">
                                <div className="user-leaderboard-img">
                                    {item.avatarUrl ? (
                                        <img src={item.avatarUrl} alt="#" />
                                    ) : (
                                        <img
                                            src="https://cdn.blotclub.am/avatars/enky1.png"
                                            alt="#"
                                        />
                                    )}
                                </div>
                                <div className="user-leaderboard-level">
                                    <span>{item.level}</span>
                                </div>
                            </div>
                            <div className="user-position-block">
                                <span className="user-position-name">
                                    {item.username
                                        ? item.username.slice(0, 7)
                                        : 'agantagexos'}
                                </span>

                                <div className={`position-btn`}>
                                    <span>{index + 1}</span>
                                </div>
                            </div>
                            <div className="user-score-block">
                                <span>{intl.messages.tournament.scores}</span>
                                <p>{item.score}</p>
                            </div>
                            <div className="user-game-count">
                                <span>
                                    {item.playedGames}/{tournament.maxGames}
                                </span>
                                {/* <div className="user-game-count-rating">
                            <div className="user-game-progress"></div>
                        </div> */}
                                <LevelBar
                                    percent={
                                        (item.playedGames * 100) /
                                        tournament.maxGames
                                    }
                                />
                            </div>
                            <div
                                className="tournament-followed-btn"
                                onClick={() => unFollowingUser(item.userId)}
                            >
                                <span>{intl.messages.tournament.unFollow}</span>
                            </div>
                        </div>
                    );
                })}
        </div>
    );
};
export default FollowedContent;
